import React from "react";
import Button from "../ui/Button";
import { ModalShell } from "../ui/ModalFrame";
import { MODAL_LAYER } from "../../constants/modalLayers";
import { MODAL_DIALOG_ACTIONS_END } from "../../constants/layoutSpacing";
import { cn } from "../../utils/cn";

const DemoSignupGateModal = ({ open, onClose, onContinueToSignup }) => {
  if (!open) return null;

  return (
    <ModalShell
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/50"
      panelClassName="bg-card rounded-lg max-w-md w-full p-6 shadow-elevation-lg"
    >
      <h3 className="text-lg font-semibold">Continue para gerar seu PDF</h3>
      <p className="text-sm text-muted-foreground mt-2">
        Crie uma conta gratuita para salvar este documento como rascunho e gerar
        o PDF no sistema.
      </p>
      <p className="text-xs text-muted-foreground mt-3">
        Seu preenchimento será recuperado automaticamente após o cadastro.
      </p>

      <div className={cn(MODAL_DIALOG_ACTIONS_END, "mt-6")}>
        <Button variant="outline" onClick={onClose}>
          Voltar
        </Button>
        <Button variant="default" onClick={onContinueToSignup}>
          Criar conta
        </Button>
      </div>
    </ModalShell>
  );
};

export default DemoSignupGateModal;
